export var withFallback = function(array, fallbackLength) {
    if (!array || array.length === 0) {
        return new Array(fallbackLength).fill(undefined);
    }
    return array;
};
